export const BRAND = {
  name: "DN Flooring",
  tagline: "Interior Design",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_dn-interiors/artifacts/1v3ptrx3_1232%20%2812%29.png",
  phones: [
    { name: "Yosyf", value: "(941) 626-5241", tel: "+19416265241" },
  ],
  email: "Dn1floor@gmail.com",
  serviceArea: "Manatee · Sarasota · Charlotte County, FL",
  counties: [
    "Manatee County, FL",
    "Sarasota County, FL",
    "Charlotte County, FL",
  ],
  hours: [
    ["Mon", "08:00 am – 06:00 pm"],
    ["Tue", "08:00 am – 06:00 pm"],
    ["Wed", "08:00 am – 06:00 pm"],
    ["Thu", "08:00 am – 06:00 pm"],
    ["Fri", "08:00 am – 06:00 pm"],
    ["Sat", "09:00 am – 04:00 pm"],
    ["Sun", "Closed"],
  ],
  socials: {
    instagram: "https://instagram.com/",
    facebook: "https://facebook.com/",
  },
  googleMapsUrl:
    "https://www.google.com/maps/place/DN+Flooring,+Remodeling+and+Design/@27.2083471,-82.5729942,128337m/data=!3m2!1e3!4b1!4m6!3m5!1s0x88dcabcd807e2461:0x84106c195dda9df!8m2!3d27.208122!4d-82.2433506!16s%2Fg%2F11f8blwf54",
};

export const NAV = [
  { path: "/", label: "Home" },
  { path: "/about", label: "About" },
  { path: "/services", label: "Services" },
  { path: "/contact", label: "Contact" },
];

export const SERVICES = [
  {
    title: "Flooring",
    blurb:
      "Hardwood, laminate, vinyl plank, tile, stairs, and carpet — installed by craftsmen who treat every plank like it's their own home.",
    points: [
      "Hardwood & Laminate",
      "Vinyl Plank & Tile",
      "Stairs & Carpet",
    ],
    image:
      "https://customer-assets.emergentagent.com/job_dn-interiors/artifacts/pznyee1f_Hardwood.png",
    span: "lg:col-span-7",
  },
  {
    title: "Carpentry",
    blurb:
      "Finish carpentry done with patience and precision — clean miter cuts, seamless joints, and trim that actually meets the wall.",
    points: [
      "Crown Molding & Baseboards",
      "Doors, Casings & Windows",
      "Millwork, Shiplap & Custom Shelving",
    ],
    image:
      "https://customer-assets.emergentagent.com/job_dn-interiors/artifacts/gie0s709_Crown%20Molding.png",
    span: "lg:col-span-5",
  },
  {
    title: "Painting",
    blurb:
      "Interior, exterior, trim, doors, and accent walls — properly prepped, primed, and finished for a result that holds up year after year.",
    points: [
      "Interior & Exterior Painting",
      "Trim & Door Painting",
      "Priming & Accent Walls",
    ],
    image:
      "https://customer-assets.emergentagent.com/job_dn-interiors/artifacts/35pyw472_Interior%20Painting.png",
    span: "lg:col-span-5",
  },
  {
    title: "Cabinets, Tile & Walls",
    blurb:
      "Custom cabinetry, tile backsplashes, statement media walls, and clean drywall finishes — the details that turn a house into a home.",
    points: [
      "Custom Cabinets",
      "Backsplash & Media Walls",
      "Drywall & Mudding",
    ],
    image:
      "https://customer-assets.emergentagent.com/job_dn-interiors/artifacts/r42u9w4d_Cabinets.png",
    span: "lg:col-span-7",
  },
];

export const ALL_TRADES = [
  "Hardwood Flooring",
  "Laminate Flooring",
  "Vinyl Flooring",
  "Tile",
  "Stairs",
  "Carpet",
  "Crown Molding",
  "Baseboards",
  "Door & Door Casings",
  "Window & Window Casings",
  "Millwork Trim",
  "Custom Shelving",
  "Shiplap",
  "Quarter Rounds",
  "Shoe Molding",
  "Interior Painting",
  "Exterior Painting",
  "Trim Painting",
  "Door Painting",
  "Priming",
  "Accent Wall Painting",
  "Cabinets",
  "Back Splash",
  "Media Wall",
  "Drywall & Mudding",
];

export const CATALOG = [
  {
    category: "Flooring",
    items: [
      {
        name: "Hardwood",
        image:
          "https://customer-assets.emergentagent.com/job_dn-interiors/artifacts/pznyee1f_Hardwood.png",
      },
      {
        name: "Laminate Flooring",
        image:
          "https://customer-assets.emergentagent.com/job_dn-interiors/artifacts/w73qr3lp_Laminate%20Flooring.png",
      },
      {
        name: "Vinyl Flooring",
        image:
          "https://customer-assets.emergentagent.com/job_dn-interiors/artifacts/3qa408nm_Vinyl%20FLooring.png",
      },
      {
        name: "Tile",
        image:
          "https://customer-assets.emergentagent.com/job_dn-interiors/artifacts/oi602cso_Tile.png",
      },
      {
        name: "Stairs",
        image:
          "https://customer-assets.emergentagent.com/job_dn-interiors/artifacts/95myd230_Stairs.png",
      },
      {
        name: "Carpet",
        image:
          "https://customer-assets.emergentagent.com/job_dn-interiors/artifacts/u89xavgt_Carpet.png",
      },
    ],
  },
  {
    category: "Carpentry",
    items: [
      {
        name: "Crown Molding",
        image:
          "https://customer-assets.emergentagent.com/job_dn-interiors/artifacts/gie0s709_Crown%20Molding.png",
      },
      {
        name: "Baseboards",
        image:
          "https://customer-assets.emergentagent.com/job_dn-interiors/artifacts/ug0hzqwn_Baseboards.png",
      },
      {
        name: "Door & Door Casings",
        image:
          "https://customer-assets.emergentagent.com/job_dn-interiors/artifacts/69upez9i_Door%20%26%20Door%20Casings.png",
      },
      {
        name: "Millwork Trim",
        image:
          "https://customer-assets.emergentagent.com/job_dn-interiors/artifacts/hw6offcl_Millwork%20Trim.png",
      },
      {
        name: "Custom Shelving",
        image:
          "https://customer-assets.emergentagent.com/job_dn-interiors/artifacts/hvt0i45n_Custom%20Shelving.png",
      },
      {
        name: "Window & Window Casings",
        image:
          "https://customer-assets.emergentagent.com/job_dn-interiors/artifacts/0nzy8zpq_Window%20%20%26%20Window%20Casings.png",
      },
      {
        name: "Shiplap",
        image:
          "https://customer-assets.emergentagent.com/job_dn-interiors/artifacts/32grpu8x_Shiplap.png",
      },
      {
        name: "Quarter Rounds",
        image:
          "https://customer-assets.emergentagent.com/job_dn-interiors/artifacts/xe7vdtjh_Quarter%20Rounds.png",
      },
      {
        name: "Shoe Molding",
        image:
          "https://customer-assets.emergentagent.com/job_dn-interiors/artifacts/oltqo3nn_Shoe%20Molding.png",
      },
    ],
  },
  {
    category: "Painting",
    items: [
      {
        name: "Interior Painting",
        image:
          "https://customer-assets.emergentagent.com/job_dn-interiors/artifacts/35pyw472_Interior%20Painting.png",
      },
      {
        name: "Exterior Painting",
        image:
          "https://customer-assets.emergentagent.com/job_dn-interiors/artifacts/36nuf556_Exterior%20Painting.png",
      },
      {
        name: "Trim Painting",
        image:
          "https://customer-assets.emergentagent.com/job_dn-interiors/artifacts/ge06t1wj_Trim%20Painting.png",
      },
      {
        name: "Door Painting",
        image:
          "https://customer-assets.emergentagent.com/job_dn-interiors/artifacts/nps4ygkm_Door%20Painting.png",
      },
      {
        name: "Priming",
        image:
          "https://customer-assets.emergentagent.com/job_dn-interiors/artifacts/u4mek7t1_Priming.png",
      },
      {
        name: "Accent Wall Painting",
        image:
          "https://customer-assets.emergentagent.com/job_dn-interiors/artifacts/kbefs97c_Accent%20Wall%20Painting.png",
      },
    ],
  },
  {
    category: "Other",
    items: [
      {
        name: "Cabinets",
        image:
          "https://customer-assets.emergentagent.com/job_dn-interiors/artifacts/r42u9w4d_Cabinets.png",
      },
      {
        name: "Back Splash",
        image:
          "https://customer-assets.emergentagent.com/job_dn-interiors/artifacts/2j1f4ckr_Back%20Splash.png",
      },
      {
        name: "Media Wall",
        image:
          "https://customer-assets.emergentagent.com/job_dn-interiors/artifacts/2cctq5c3_Media%20Wall.png",
      },
      {
        name: "Drywall & Mudding",
        image:
          "https://customer-assets.emergentagent.com/job_dn-interiors/artifacts/hqio4jol_Drywall%20%26%20Mudding.png",
      },
    ],
  },
];

export const WORK = [
  {
    title: "Lakewood Ranch Residence",
    location: "Manatee County",
    image:
      "https://images.unsplash.com/photo-1776935359455-94263068537c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    tags: ["Flooring", "Cabinets", "Tile"],
  },
  {
    title: "Siesta Key Retreat",
    location: "Sarasota County",
    image:
      "https://images.pexels.com/photos/30666576/pexels-photo-30666576.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
    tags: ["Interior Design", "Painting"],
  },
  {
    title: "Punta Gorda Build",
    location: "Charlotte County",
    image:
      "https://images.pexels.com/photos/6264414/pexels-photo-6264414.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
    tags: ["Cabinets", "Carpentry"],
  },
  {
    title: "University Park Master Bath",
    location: "Sarasota County",
    image:
      "https://images.pexels.com/photos/35189678/pexels-photo-35189678.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
    tags: ["Tile", "Drywall"],
  },
];

export const TEAM = [
  {
    name: "Founder & Lead Designer",
    role: "Strategy · Client Experience",
    image:
      "https://images.pexels.com/photos/10657877/pexels-photo-10657877.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    name: "Master Craftsman",
    role: "Carpentry · Cabinetry",
    image:
      "https://images.pexels.com/photos/36934779/pexels-photo-36934779.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    name: "Project Manager",
    role: "Scheduling · Site Lead",
    image:
      "https://images.pexels.com/photos/10657877/pexels-photo-10657877.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];
